import { useMemo, useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import { CacheProvider, ThemeProvider } from '@emotion/react';
import { FontsLoader } from '../FontsLoader.js';
import { GigerConfigProvider } from '../GigerConfigProvider.js';
import { THEME_ID } from './useTheme.js';
import createCache from '@emotion/cache';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { EmotionReset } from '../EmotionReset/EmotionReset.js';

function GigerProvider(_ref) {
  let {
    theme,
    children,
    cdnUrl,
    reference,
    emotionCacheShadowRootContainer,
    resolveIcon
  } = _ref;
  const scope = typeof reference === 'string' ? reference : undefined;
  const elementReference = useMemo(() => {
    if (typeof window === 'undefined') return undefined;
    if (!emotionCacheShadowRootContainer) {
      if (typeof reference === 'string') {
        const idReference = document.getElementById(reference);
        if (idReference) {
          return idReference;
        }
        const classReference = document.getElementsByClassName(reference)[0];
        if (classReference) {
          return classReference;
        }
        return undefined;
      } else {
        return reference;
      }
    } else {
      return undefined;
    }
  }, [reference, emotionCacheShadowRootContainer]);
  const themeLens = useCallback(outerTheme => {
    if (isEmpty(outerTheme)) {
      return theme;
    }
    if (!isEmpty(outerTheme) && !(THEME_ID in theme)) {
      return {
        ...outerTheme,
        [THEME_ID]: theme
      };
    }
    return {
      ...outerTheme,
      ...theme
    };
  }, [theme]);
  const emotionCache = useMemo(() => {
    return createCache({
      key: scope || 'giger',
      container: emotionCacheShadowRootContainer
    });
  }, [emotionCacheShadowRootContainer, scope]);
  return jsx(CacheProvider, {
    value: emotionCache,
    children: jsxs(ThemeProvider, {
      theme: themeLens,
      children: [jsx(FontsLoader, {
        theme: THEME_ID in theme ? theme[THEME_ID] : theme,
        cdnUrl: cdnUrl,
        emotionCacheShadowRootContainer: emotionCacheShadowRootContainer,
        reference: elementReference,
        scope: scope
      }), jsx(EmotionReset, {
        reference: elementReference,
        scope: scope,
        emotionCacheShadowRootContainer: emotionCacheShadowRootContainer
      }), jsx(GigerConfigProvider, {
        emotionCacheShadowRootContainer: emotionCacheShadowRootContainer,
        resolveIcon: resolveIcon,
        children: children
      })]
    })
  });
}

export { GigerProvider };
//# sourceMappingURL=GigerProvider.js.map
